import React, { useEffect, useState } from 'react';
import withStyles from '../../../../common/hoc/withStyles';
import styles from '../styles/BIACombinedCarousel.style';
import BIACarousel from '../molecules/BIACarousel.view';
import BuyItAgainBagPageLabels, { ACCOUNT_COMMON } from './BuyItAgainBagPage.labels';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import { capitalizeWords } from '../../../../../utils/utils';

const getFirstChildLabel = (props) => {
  const { children } = props || {};
  return Array.isArray(children) ? children.find(Boolean)?.props?.label : null;
};

const Tabs = (props) => {
  const { isLoggedIn, showOutfitsOnBag } = props;
  const label = getFirstChildLabel(props);
  const [activeTab, setActiveTab] = useState(label);

  const changeTab = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    setActiveTab(label);
  }, [isLoggedIn, label, showOutfitsOnBag]);
  let content;
  const buttons = [];
  React.Children?.forEach(props.children, (child) => {
    if (child && child.props) {
      buttons.push(child?.props.label);
      if (child?.props.label === activeTab) {
        content = child?.props.children;
      }
    }
  });
  return (
    <div>
      <TabButtons activeTab={activeTab} buttons={buttons} changeTab={changeTab} />
      <div>{content}</div>
    </div>
  );
};

const TabButtons = ({ buttons, changeTab, activeTab }) => {
  return (
    <div className="tab-buttons">
      {buttons.map((button) => {
        return (
          <button
            className={button === activeTab ? 'active' : 'tab-btn'}
            onClick={() => changeTab(button)}
          >
            {button}
          </button>
        );
      })}
    </div>
  );
};

const Tab = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

const BIACombinedCarousel = (props) => {
  const accountCommonLabels = getLabelFromCopyOrFromTranslation(
    ACCOUNT_COMMON,
    BuyItAgainBagPageLabels
  );
  const {
    className,
    biaProducts,
    isLoggedIn,
    orderItemsCount,
    spcBag,
    renderRecommendations,
    renderBagPageOutfits,
    isBIACombinedCarouselEnabled,
    isOutfitsOnBagEnabled,
    showOutfitsOnBag,
  } = props;
  const payload = {
    fromBIA: true,
  };
  const isNoNEmptyBag = orderItemsCount > 0;

  const recomLabel = isNoNEmptyBag
    ? getDynamicLabelValues('dynamic.cart.lbl_you_may_also_like_full_bag_page')
    : getDynamicLabelValues('dynamic.cart.lbl_you_may_also_like_empty_bag_page');
  return (
    <div>
      <div className={className}>
        <div className="tabs">
          <Tabs {...props}>
            {(isBIACombinedCarouselEnabled || isOutfitsOnBagEnabled) && (
              <Tab label={capitalizeWords(recomLabel)}>
                <div>{renderRecommendations(props, payload)}</div>
              </Tab>
            )}
            {showOutfitsOnBag && (
              <Tab label="Complete The Look">
                <div>{renderBagPageOutfits()}</div>
              </Tab>
            )}
            {isBIACombinedCarouselEnabled && isLoggedIn && biaProducts?.length > 2 && (
              <Tab
                label={` ${renderLabel(
                  accountCommonLabels?.lbl_bia_main_title,
                  'lbl_bia_main_title'
                )} `}
              >
                <div>
                  <BIACarousel
                    {...props}
                    isNoNEmptyBag={isNoNEmptyBag}
                    orderItemsCount={orderItemsCount}
                    spcBag={spcBag}
                  />
                </div>
              </Tab>
            )}
          </Tabs>
        </div>
      </div>
    </div>
  );
};
export default withStyles(BIACombinedCarousel, styles);
export { BIACombinedCarousel as BIACombinedCarouselVanilla };
